import { css } from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';

export const HeaderStyle = css<{ readonly $hasTitle: boolean }>`
  display: flex;
  justify-content: space-between;
  margin: 12px 12px 0;
  font-size: ${fontSize.px12};

  ${({ $hasTitle, theme }) =>
    $hasTitle
      ? css`
          /* モジュールタイトルが存在するときは、サブ見出しに下罫線をつける */
          position: relative;
          padding-bottom: 8px;
          border-bottom: 1px solid ${theme.news.palette.bor_lv1_pc};

          /* モジュールタイトルが存在するときは、サブ見出しとモジュールタイトル間の余白をなくす */
          &:first-of-type {
            margin-top: 0;
          }
        `
      : ``}
`;

export const HeadingStyle = css`
  display: flex;
`;

export const HeadingTitleStyle = css`
  font-weight: bold;
  color: ${props => props.theme.news.palette.text_base_common};
`;

export const SportsNavStyle = css`
  display: flex;
`;

export const SportsNavItemStyle = css`
  & + & {
    position: relative;
    padding-left: 17px;

    &::before {
      position: absolute;
      top: 50%;
      left: 8px;
      display: block;
      width: 1px;
      height: 12px;
      content: '';
      background-color: ${props => props.theme.news.palette.bor_lv2_pc};
      transform: translateY(-50%);
    }
  }
`;

export const SportsBodyStyle = css`
  padding: 12px;
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc}; /* 試合枠が複数ある時は、試合枠間に罫線を入れる */

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 12px; /* 後続モジュールに上marginがあると下paddingとあわさって倍になるので、最後の要素は相殺できるようmarginでつける。 */
    border-bottom: 0; /* 最後の試合枠の要素には罫線を付けない */
  }
`;

export const SportsListStyle = css`
  display: flex;
  flex-wrap: wrap;
  margin-left: -20px;
  font-size: ${fontSize.px14};
`;

export const SportsItemStyle = css`
  margin-left: 20px;
  line-height: 1.5;
`;
